import { EmbeddedVideoStyled, EmbeddedVideoWrapper, videoSizes } from './styles'

export const sizes = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
})

const EmbeddedVideo = ({
  src,
  block,
  ratio = 16 / 9,
  size = sizes.MEDIUM,
  blockProps
}) => {
  const source = src ? src : block ? block.getData().get('src') : null
  let aspectRatio = (block && block.getData().get('ratio')) || ratio
  aspectRatio = Math.max(aspectRatio, videoSizes.minRatio)
  aspectRatio = Math.min(aspectRatio, videoSizes.maxRatio)

  const vSize = videoSizes[(blockProps && blockProps.size) || size]
  let width, height
  if (aspectRatio > vSize.maxWidth / vSize.maxHeight) {
    width = vSize.maxWidth
    height = width / aspectRatio
  } else {
    height = vSize.maxHeight
    width = height * aspectRatio
  }

  if (!source) {
    return null
  } else {
    return (
      <EmbeddedVideoWrapper width={width} height={height}>
        <EmbeddedVideoStyled
          src={source}
          allow="fullscreen"
        ></EmbeddedVideoStyled>
      </EmbeddedVideoWrapper>
    )
  }
}

export default EmbeddedVideo

export const VIDEO_PLACEHOLDER_CLASS = 'loom-embed-placeholder'
